/**
 * Csv Schema of ResponsavelSaraiva
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {ResponsavelSaraiva} from '@/model/resource/ResponsavelSaraiva'

/* TODO: review generated schema */
export class CsvResponsavelSaraivaSchema extends Schema {
  readonly name = 'CsvResponsavelSaraiva'

  readonly fieldSet: FieldSet<ResponsavelSaraiva> = {
    idResponsavelSaraivaPk: schema => schema.model.idResponsavelSaraivaPk,
    responsavel: schema => schema.model.responsavel?.$id ?? null,
  }
}
